// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XvdP","content":"styles_content__2lwH0","row":"styles_row__2RcIz","footer":"styles_footer__14myS","phraseLength":"styles_phraseLength__2Hpam"};